






















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import * as service from '@/services/expressions';
import * as serviceMeasurementUnit from '@/services/measurement-unit';
import IExpression from '@/interfaces/expression';
import { IMeasurementUnit } from '@/interfaces/measurement-unit';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { filterByText } from '@/helpers/filterByText';
import { errorHandling } from '@/helpers/errorHandling';
import { MESSAGE_EXPRESSIONS_DELETE_ERROR } from '@/settings/consts/messages';
import { ERROR_CODE_EXPRESSIONS_DELETE } from '@/settings/consts/api-error';

@Component({
  components: { ListMessages, PermissionAuth },
})
export default class Expressions extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
  };

  public form: any = {
    valid: false,
    rules: {
      description: [(v) => !!v || 'Digite uma descrição'],
      function: [(v) => !!v || 'Digite uma função'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Descrição', value: 'descricao' },
    { text: 'Função', value: 'funcao' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: IExpression[] = [];
  public item: IExpression = {
    id: 0,
    descricao: '',
    funcao: '',
  };

  public beforeMount(): void {
    this.load();
  }

  public onEditItem(item: IExpression): void {
    this.formOpen = true;
    this.item = cloneDeep(item);
  }

  public onDeleteItem(item: IExpression): void {
    const deleteItem = () => {
      const onError = (error) => {
        this.loader.stop();

        const errorMessages = {
          default: MESSAGE_EXPRESSIONS_DELETE_ERROR,
          [ERROR_CODE_EXPRESSIONS_DELETE]:
            !!error && !!error.data
              ? error.data.message
              : MESSAGE_EXPRESSIONS_DELETE_ERROR,
        };

        const message = errorHandling(error, errorMessages);
        this.toast.show(message, 'error');
      };

      this.loader.start('Deletando registro...');
      service.deleteExpression(item.id).subscribe((data) => {
        this.loader.stop();
        this.load();
      }, onError);
    };

    this.dialog.show(
      'error',
      'Excluir Expressão',
      'Tem certeza que deseja excluir esta expressão?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return filterByText(row, ['descricao', 'funcao'], searchLower);
    });
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    if (!this.item.id) {
      service.saveExpression(cloneDeep(this.item)).subscribe(
        (data) => {
          this.loader.stop();
          this.formOpen = false;
          this.load();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao criar o registro', 'error');
        },
      );
    } else {
      service.updateExpression(cloneDeep(this.item)).subscribe(
        (data) => {
          this.loader.stop();
          this.formOpen = false;
          this.load();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao atualizar o registro', 'error');
        },
      );
    }
  }

  public newItem(): void {
    this.formOpen = true;
    this.item = {
      id: 0,
      descricao: '',
      funcao: '',
    };
    this.$refs.form.resetValidation();
  }

  public closeForm(): void {
    const closeAction = () => {
      this.formOpen = false;
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    service.getExpressions().subscribe(
      (data) => {
        this.data = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
